<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Product Description</h2>
            <p class="demo-description">Edit a product's text content using <code>upp-textarea</code> with validation and character counting.</p>

            <div class="demo-controls">
    <ion-button size="small" (click)="toggleReadonly()">Readonly: {{ isReadonly }}</ion-button>
    <ion-button size="small" color="warning" (click)="validate()">Validate</ion-button>
    <ion-button size="small" color="medium" (click)="resetForm()">Reset</ion-button>
</div>
            <p class="demo-hint">Validation errors appear when the field is touched (blur) or dirty. Leave the required field empty and blur to see errors.</p>

<div class="demo-section" [formGroup]="form">
    <h3>Product Copy</h3>

    <ion-list lines="none">
        <ion-item>
            <upp-textarea
                formControlName="shortDescription"
                placeholder="A brief summary of the product..."
                title="Short Description (required) &mdash; {{ shortDescriptionLength }} chars"
                [rows]="2"
                [readonly]="isReadonly"
                [kiosk]="false"
                [errornfo]="errorMessages">
            </upp-textarea>
        </ion-item>

        <ion-item>
            <upp-textarea
                formControlName="detailedNotes"
                placeholder="Ingredients, allergens, storage instructions..."
                title="Detailed Notes (optional) &mdash; {{ detailedNotesLength }} chars"
                [rows]="5"
                [readonly]="isReadonly"
                [kiosk]="false">
            </upp-textarea>
        </ion-item>
    </ion-list>
</div>
        </div>
    </upp-scrollable>
</div>
